import { render, staticRenderFns } from "./PersonalList.vue?vue&type=template&id=02cf6620&scoped=true&lang=html"
import script from "./PersonalList.vue?vue&type=script&lang=js"
export * from "./PersonalList.vue?vue&type=script&lang=js"
import style0 from "./PersonalList.vue?vue&type=style&index=0&id=02cf6620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cf6620",
  null
  
)

export default component.exports